<template>
  <v-card>
    <v-card-title>
      {{ $t('REPORTS.EMERGENCY_DEVICES') }}
    </v-card-title>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>
      <v-btn @click="getEmergencyDevices">
        {{ $t('BUTTON.EXPORT') }}
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import downloadFile from '@/modules/_global/mixins/download-file';

export default {
  name: 'EmergencyDevices',

  mixins: [downloadFile],

  data: () => ({
    datetimeNow: ''
  }),

  created() {
    this.datetimeNow = new Date().toISOString().slice(0, 10);
  },

  methods: {
    getEmergencyDevices() {
      return this.$store
        .dispatch('report/retrieveEmergencyDevices')
        .then(response => {
          let rootName = this.$t('REPORTS.EMERGENCY_DEVICES');

          this.downloadFile(
            response,
            `${rootName}${this.datetimeNow}.xlsx`
          );
        })
        .catch(error => {
          this.error = error.response;
        });
    }
  }
};
</script>
